<template>
  <!-- .et ex-tool -->
  <div class="et">
    <div class="item item3" v-if="isZT">
      <img src="../../../assets/img/new/icon-win.png" width="50" />
    </div>
    <!-- <div class="item item2" v-if="isZX">
      <img v-if="exhibitionInfo.logo||exhibitionInfo.exhibition.logo" :src="exhibitionInfo.logo||exhibitionInfo.exhibition.logo" class="img2 icon" />
      <img v-else src="../../../assets/img/empty.png" >
      <div class="item2-txt">免费咨询</div>
    </div> -->
    <!-- <div class="item itme_live item_ic" v-if="isLive" @click="toolTouch('live')">
      <img src="@/assets/img/live/tool-icon-live.png"/>
    </div> -->
    <div class="item item_ic item_icon1" v-if="isCG" @click="goToReg">
      <i class="iconfont icon-11"></i>
      <p>Register</p>
    </div>
    <div class="item item_ic item_icon1 share" v-if="isWeixin&&isFX" @click="shareClick">
      <i class="iconfont icon-zhuanfa"></i>
      <p>Share</p>
    </div>
    <div class="item item_ic" v-if="isShowTop && isTop" @click="goTop">
      <i class="iconfont icon-huidingbu"></i>
    </div>
    <div class="item no_go_top" v-else></div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
export default {
  name: "ex-tool",
  props:{
    isZT:{
      type:Boolean,
      default:false,
    },
    isZX:{
      type:Boolean,
      default:false,
    },
    isCG:{
      type:Boolean,
      default:true,
    },
    isFX:{
      type:Boolean,
      default:false,
    },
    isTop:{
      type:Boolean,
      default:true,
    },
    isLive:{
      type:Boolean,
      default:false,
    }
  },
  data() {
    return {
      isShowTop:false,
      scroll_:null,
    };
  },
  computed:{
    ...mapGetters({
      exhibitionInfo:'getExhibitionInfo',
      userInfo:'getUserInfo',
      isWeixin: "getIsWeixin",
    })
  },
  mounted(){
   
    this.scroll_=()=>{
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop)
      if(scrollTop>500){
        this.isShowTop=true
      }else{
        this.isShowTop=false
      }
    }
    window.addEventListener('scroll',this.scroll_)
  },
  beforeDestroy(){
    if(this.scroll_){
      window.removeEventListener('scroll',this.scroll_)
    }
  },
  methods:{
     ...mapActions({
      LinkToReg:"linkTo/LinkToReg"
    }),
    //分享点击
    shareClick(){
      this.$emit('shareClick')
    },
   //回到顶部
    goTop(){
      $('html , body').stop().animate({scrollTop: 0},'1000');
    }, 
    goToReg(){
      if(this.userInfo&&this.userInfo.inMember.userRole.toUpperCase()!='VISITOR'){
        this.$toast('You have already registered')
        return 
      }else{
        this.LinkToReg()
      }
    },
    toolTouch(type){
      this.$emit('toolTouch',type);
    },
  }
};
</script>

<style lang="scss" scoped>
.et {
  position: fixed;
  z-index: 12;
  bottom: 1.18rem;
  right: 0.3rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 1rem;
  justify-content: center;
  .item {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    text-align: center;
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 0.4rem;
    position: relative;
    background: #fff;
    &.item_ic{
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
      width: 0.92rem;
      height: 0.92rem;
    }
    .icon-huidingbu{
      
      color: #666;
      transform: scale(1.8) translateY(0.03rem);
    }
    &.item_icon1{
      flex-direction: column;
      color:#ff5e00;
      &.share{
        color: #666;
        .iconfont{
          transform: scale(1.6);
        }
      }
      .icon-11{
        transform:scale(1.6) translateX(0.01rem);
      }
      p{
        font-size: 0.2rem;
      }
    }
    .icon {
      width: 1rem;
      height: 1rem;
    }
    &.item3 {
      width: 1rem;
      align-items: flex-end;
      justify-content: center;
      position: relative;
      margin-top: 0;
      background: rgba(0, 0, 0, 0);
    }
    &.item2 {
      width: 1rem;
      height: 1rem;
      margin-bottom: 0.15rem;
      border-radius: 50%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
      flex-wrap: wrap;
      color: #ff416c;
      position: relative;
      box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
      img {
        display: block;
        width: 1rem;
        height: 1rem;
        border: 0.04rem solid #fff;
        border-radius: 50%;
      }
      .item2-txt {
        font-size: 0.2rem;
        position: absolute;
        width: 0.92rem;
        height: 0.38rem;
        line-height: 0.38rem;
        background-color: #fff;
        box-shadow: 0px 0.03rem 0.07rem 0px rgba(0, 0, 0, 0.2);
        border-radius: 0.18rem;
        border: solid 0.02rem #ff4b1b;
        bottom: -0.15rem;
      }
      &.s-red {
        background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
          linear-gradient(#fff, #fff);
        color: #fff;
      }
    }
    &.no_go_top{
      width: 0.92rem;
      height: 0.92rem;
      background: rgba(0, 0, 0, 0);
    }
  }
  
}
.itme_live{
  img{
    width: 100%;
    height: 100%;
  }
}
.img1 {
  width: 0.35rem;
  height: 0.43rem;
}
.img2 {
  width: 0.4rem;
  height: 0.38rem;
}
.img3 {
  width: 0.37rem;
  height: 0.4rem;
}
.z-side {
  position: relative;
  .list {
    flex: 1;
    width: 3.33rem !important;
    height: 0.92rem;
    position: absolute;
    right: 1.02rem;
    top: 0;
    .list-box {
      width: 100%;
      height: 0.92rem;
      padding-right: 0.16rem;
    }
    .item3 {
      width: 100%;
      height: 0.92rem;
      border: 0.02rem solid #e6b54a;
      border-right-color: transparent;
      background-image: url("../../../assets/img/live/crown.png"),
        linear-gradient(90deg, #4b1248 0%, #9e6a62 49%, #f0c27b 100%),
        linear-gradient(#2b1e08, #2b1e08);
      background-repeat: no-repeat;
      background-position: bottom right, 0% 0%;
      background-size: 0.52rem 0.52rem, auto;
      border-radius: 0.06rem;
      position: relative;
      text-align: left;
      padding: 0.1rem;
      display: flex;
      &::after {
        content: "";
        position: absolute;
        right: -0.18rem;
        top: 50%;
        margin-top: -0.1rem;
        border-width: 0.1rem;
        border-style: solid;
        border-color: transparent;
        border-left-color: #ecbe78;
      }
      .logo {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.02rem;
        border: 0.02rem solid #f0cc3a;
        margin-right: 0.1rem;
      }
      .content {
        width: calc(100% - 0.8rem);
        height: 0.7rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        p {
          font-size: 0.2rem;
          color: #fff;
          font-weight: bold;
          margin: 0;
          width: 100%;
          line-height: 1.2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .txt {
          font-size: 0.16rem;
          color: #fff;
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.2;
        }
        .tag {
          display: flex;
          .info_img {
            width: 0.46rem;
            height: 0.2rem;
            display: flex;
            img {
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
              border: 1px solid #fff;
              // object-fit: cover;
              &:nth-child(1) {
                position: relative;
                z-index: 3;
              }
              &:nth-child(2) {
                position: relative;
                z-index: 2;
                margin-left: -0.07rem;
              }
              &:nth-child(3) {
                position: relative;
                z-index: 1;
                margin-left: -0.06rem;
              }
            }
          }
          span {
            font-size: 0.14rem;
            margin-left: 0.1rem;
            line-height: 0.2rem;
          }
        }
      }
    }
  }
}
</style>